/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Session_Already_OpenInputs */

const en_us2_workout_session_already_open = /** @type {(inputs: Workout_Session_Already_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Another workout is still open. Finish it before starting a new one.`)
};

const pt_br2_workout_session_already_open = /** @type {(inputs: Workout_Session_Already_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro treino ainda está aberto. Encerre ele antes de começar um novo.`)
};

const es_419_workout_session_already_open = /** @type {(inputs: Workout_Session_Already_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otro entrenamiento sigue abierto. Termínalo antes de empezar uno nuevo.`)
};

const pt_pt2_workout_session_already_open = /** @type {(inputs: Workout_Session_Already_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há outro treino ainda aberto. Termina-o antes de começares um novo.`)
};

const fr_fr2_workout_session_already_open = /** @type {(inputs: Workout_Session_Already_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une autre séance est encore ouverte. Termine-la avant d'en commencer une nouvelle.`)
};

const de_de2_workout_session_already_open = /** @type {(inputs: Workout_Session_Already_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein anderes Training ist noch offen. Beende es, bevor du ein neues startest.`)
};

const it_it2_workout_session_already_open = /** @type {(inputs: Workout_Session_Already_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un altro allenamento è ancora aperto. Concludilo prima di iniziarne uno nuovo.`)
};

/**
* | output |
* | --- |
* | "Another workout is still open. Finish it before starting a new one." |
*
* @param {Workout_Session_Already_OpenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_session_already_open = /** @type {((inputs?: Workout_Session_Already_OpenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Session_Already_OpenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_session_already_open(inputs)
	if (locale === "es-419") return es_419_workout_session_already_open(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_session_already_open(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_session_already_open(inputs)
	if (locale === "de-DE") return de_de2_workout_session_already_open(inputs)
	if (locale === "it-IT") return it_it2_workout_session_already_open(inputs)
	return en_us2_workout_session_already_open(inputs)
});
export { workout_session_already_open as "workout.session_already_open" }